export function getViewportSize(wndw) {
  return {
    VIEWPORT_HEIGHT: wndw.innerHeight,
    VIEWPORT_WIDTH: wndw.innerWidth,
  };
}

export function getBrowserStats(wndw) {
  const viewportSize = getViewportSize(wndw);
  return {
    DEVICE_PIXEL_RATIO: wndw.devicePixelRatio || 1,
    SCREEN_HEIGHT: wndw.screen.height,
    SCREEN_WIDTH: wndw.screen.width,
    ...viewportSize,
  };
}
